import { ControllerPaletteColor } from './__palette-color';

export enum ControllerSentimentColor {
  SentimentDissatisfied = ControllerPaletteColor.Red400,
  SentimentNeutral = ControllerPaletteColor.SyntaxOrange,
  SentimentSatisfied = ControllerPaletteColor.SyntaxYellow,
  SentimentVerySatisfied = ControllerPaletteColor.Minty300,
}
